import { Trash2, Download, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';
import { useState } from 'react';
import { useWallpapersContext } from '../contexts/WallpapersContext';

export function WallpapersHistory() {
  const { wallpapers, loading, deleteWallpaper } = useWallpapersContext();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleDownload = async (url: string, name: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name.split('-').slice(1).join('-'); // Enlever le timestamp du nom
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Nettoyer l'URL de l'objet blob
      window.URL.revokeObjectURL(blobUrl);
      
      toast.success('Téléchargement du fond d\'écran lancé');
    } catch (error) {
      console.error('Erreur lors du téléchargement:', error);
      toast.error('Erreur lors du téléchargement');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (wallpapers.length === 0) {
    return (
      <div className="text-center p-8 text-gray-500">
        Aucun fond d'écran généré pour le moment
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-4">
        {wallpapers.map((wallpaper) => (
          <div
            key={wallpaper.url}
            className="relative group bg-white rounded-lg shadow-md overflow-hidden cursor-pointer"
            onClick={() => setSelectedImage(wallpaper.url)}
          >
            <img
              src={wallpaper.url}
              alt="Fond d'écran"
              className="w-full h-48 object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <div className="flex space-x-4">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownload(wallpaper.url, wallpaper.name);
                  }}
                  className="p-2 bg-white rounded-full hover:bg-gray-100 transition-colors"
                  title="Télécharger"
                >
                  <Download className="h-5 w-5 text-gray-700" />
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteWallpaper(wallpaper.name);
                  }}
                  className="p-2 bg-white rounded-full hover:bg-gray-100 transition-colors"
                  title="Supprimer"
                >
                  <Trash2 className="h-5 w-5 text-red-600" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal pour l'aperçu en grand */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4 overflow-y-auto"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full max-h-[90vh] flex items-center justify-center">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-10 right-0 p-2 bg-white rounded-full hover:bg-gray-100 transition-colors z-10"
            >
              <X className="h-6 w-6 text-gray-700" />
            </button>
            <img
              src={selectedImage}
              alt="Aperçu en grand"
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
}